import { useSearchParams } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { ContactForm } from "../components/ContactForm";

export default function Contact() {
  const { copy } = useLanguage();
  const [params] = useSearchParams();
  const service = params.get("servicio") || "general";

  return (
    <main className="pt-28 pb-24 sm:pt-36" data-testid="contact-page">
      <Seo title={copy.seo.contact.title} description={copy.seo.contact.desc} />
      <div className="max-w-3xl mx-auto px-5">
        <Reveal>
          <div className="text-center mb-10">
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-clay font-semibold mb-3">{copy.contact.eyebrow}</p>
            <h1 className="font-serif font-semibold text-4xl sm:text-5xl text-ink tracking-tight">{copy.contact.title}</h1>
            <p className="mt-4 text-muted">{copy.contact.sub}</p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-3xl bg-white border border-border p-6 sm:p-9 shadow-sm">
            <ContactForm key={service} preselectedService={service} />
          </div>
        </Reveal>
      </div>
    </main>
  );
}
